 import { DOCUMENT } from '@angular/common';
import { Component, ElementRef, Inject, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import * as moment from 'moment';
import { debounceTime } from 'rxjs/operators';
import { PageBase, RentalContractInfo, OrderCustomerModel, TurboHubEventType, UserDropDownModel, ViewOrderModel, ViewOrderRowsModel, ViewPriceListModel, ViewPriceListRowModel, ItemOrderInfo } from 't4core';
import { NewOrderDialog } from '../../dialogs/neworder/neworder';
import { MatCheckboxChange } from '@angular/material/checkbox';



@Component({
    selector: 'order',
    templateUrl: './order.html',
    styleUrls: ['./order.css']
})
export class OrderComponent extends PageBase implements OnInit {
    constructor( private router: Router, private route: ActivatedRoute, el: ElementRef) {
        super(el, "Order");
    }
    
    async ngOnInit() {
      this.route.params.subscribe(params => {
          if(params.Id != 0) this.orderId = +params.Id;
        this.order.Ownership = "Financed";
        this.order.Concept = "BC_B2B";
        this.order.OwnerId = this.Settings.getEffectiveUser().Username;
        this.order.AddServiceFee = true;
            this.loadUsers();
        if (!isNaN(this.orderId) && this.orderId != 0) {
              // TODO Implement signal R
                //this.SignalR.sub(TurboHubEventType.Order).pipe(debounceTime(1000)).subscribe(x => {
                //    if (x.Data == this.orderId.toString())
                //        this.loadOrder();
                //});

                this.loadOrder();
            }
            else {
                let dialog = this.Dialog.open(NewOrderDialog);
                dialog.afterClosed().toPromise().then(async (result) => {
                    if (result) {
                        this.order.OrderRows = [];
                        this.order.Status = 0;
                        this.state.readonly = false;
                        this.order.PaymentAtBeginningOfPeriod = true;
                      this.order.Duration = 48;

                      this.order.Ownership = "Financed";
                      this.order.Concept = "BC_B2B";

                        if(result.selectedCustomerId > 0)
                            await this.loadCustomerInfo(result.selectedCustomerId, '');

                        else if (result.selectedPricelistId > 0) {
                            await this.loadCustomerInfo(0, result.orgNo);
                            this.order.PriceListId = result.selectedPricelistId;
                            await this.changePricelist();
                        }

                    } else {
                        this.router.navigateByUrl("/TurboOrder");
                    }
                });
            }
        });
    }

    // Data model
    private serviceArticle: ViewOrderRowsModel = {
        ArticleNo: '500000',
        Alias: 'Service',
        Description: 'Service according to agreement',
        IsStandardArticle: true,
        Id: 0,
        SalesPrice: 0,
        ConceptFee: 0,
        ServiceFee: 0,
        Amount: 1,
        TotalCost: 0,
        OriginalValue: null,
        BuyBackValue: null,
        ReplacementCount: 0,
    };

    private conceptArticle: ViewOrderRowsModel = {
        ArticleNo: '600000',
        Alias: 'Koncept',
        Description: 'Concept fee',
        IsStandardArticle: true,
        Id: 0,
        SalesPrice: 0,
        ConceptFee: 0,
        ServiceFee: 0,
        Amount: 1,
        TotalCost: 0,
        OriginalValue: null,
        BuyBackValue: null,
        ReplacementCount: 0,
    };

    public ownerships: any[] = [{
        value: "Financed",
        text: "Financed"
    }, {
        value: "Own",
        text: "Own",
      }, {
        value: "SellAndLeaseBack",
        text: "Sell and lease back",
      }];

  public concepts: any[] = [{
    value: "BC_B2B",
    text: "B2B"
  }, {
    value: "BC_U4F",
      text: "Use4Free"
    }, {
    value: "BC_24Rent",
      text: "24Rental"
    }, {
    value: "BC_OneWay",
      text: "OneWay"
    }];

    public priceList: ViewPriceListModel;
    public users: UserDropDownModel[] = [];
    public items: ItemOrderInfo[] = [];

    // View model
    private orderId: number = 0;
  public order: ViewOrderModel = new ViewOrderModel();
  public paymentTerms: number = 0;
    public trailers: RentalContractInfo[] = [];
  public dllData: any;
  public customerNumber: string;

    public state: any = {
        showDLL: false,
        readonly: true
    };

    public loading: any = {
        customer: false
    };

    public total: any = {
      amount: 0,
        ReplacementCount: 0,
        cost: 0,
        salesValue: 0
    };

    public txtArticleNo = new FormControl();
    public filteredArticles: ViewPriceListRowModel[] = [];


    // Functions
    private updateTotal(): any {
        var concept = 0;
        var service = 0;
        this.total.cost = 0;
        this.total.amount = 0;
        this.total.salesValue = 0;
        this.total.ReplacementCount = 0;

        if (this.order.OrderRows != undefined) {
            for (var i = 0; i < this.order.OrderRows!.length; i++) {
                var order = this.order.OrderRows![i];

                var lineCost = this.order.AddServiceFee ? order.TotalCost : order.TotalCost - order.ServiceFee!;

                if (!order.IsStandardArticle) {
                  this.total.amount += order.Amount;
                  this.total.cost += ((order.Amount + order.ReplacementCount ?? 0) * lineCost);
                  this.total.ReplacementCount += order.ReplacementCount ?? 0;
                  concept += order.ConceptFee! * order.Amount;
                  service += order.ServiceFee! * order.Amount;
                }
            }    
        }
     

        if (this.order.OrderRows!.indexOf(this.conceptArticle) >= 0) this.order.OrderRows!.splice(this.order.OrderRows!.indexOf(this.conceptArticle), 1);
        if (this.order.OrderRows!.indexOf(this.serviceArticle) >= 0) this.order.OrderRows!.splice(this.order.OrderRows!.indexOf(this.serviceArticle), 1);
        if (this.order.OrderRows!.indexOf(this.serviceArticle) >= 0 && !this.order.AddServiceFee) this.order.OrderRows!.splice(this.order.OrderRows!.indexOf(this.serviceArticle), 1);

        this.serviceArticle.SalesPrice = service;
        this.conceptArticle.SalesPrice = concept;

        if (this.priceList.Fees.toLowerCase().indexOf("service") >= 0 && this.order.AddServiceFee) this.order.OrderRows!.push(this.serviceArticle);
        if (this.priceList.Fees.toLowerCase().indexOf("concept") >= 0) this.order.OrderRows!.push(this.conceptArticle);
    }

    // Commands
    public async changeCustomer() {
        let dialog = this.Dialog.open(NewOrderDialog);
        dialog.afterClosed().toPromise().then(async (result) => {
            if (result) {
                if (result.selectedCustomerId > 0)
                    this.loadCustomerInfo(result.selectedCustomerId, '', false);

                else if (result.selectedPricelistId > 0) {
                    this.loadCustomerInfo(0, result.orgNo, false);
                    this.order.PriceListId = result.selectedPricelistId;
                    await this.changePricelist(false);
                }

            }
        });
    }

    public updateStartDate() {
        var nextMonth = moment(this.order.RequestedDeliveryDate!).startOf('month').add(1, 'month');

        this.order.RequestedStartDate = nextMonth;
        this.updateTotal();
    }

    public getArticlePrice(articleNo: string) {
        var article = this.priceList.Rows!.filter(function (n, i) {
            return n.ArticleNo === articleNo;
        })[0];

        return article;
    }

    // Article search
  public articleSearch(query: string) {
        if (query === '') {
            this.filteredArticles = this.priceList.Rows!.slice(0, 50);
            return;
        }

        var count = 0;
        this.filteredArticles = this.priceList.Rows!.filter(function (item) {
            if (count > 50) return false;

            if ((item.ArticleNo.toLowerCase().indexOf(query.toLowerCase()) > -1 || item.Description.toLowerCase().indexOf(query.toLowerCase()) > -1)) {
                count++;
                return true;
            }

            return false;
        });
    }

    // Order row handling
    public addOrderRow(item: ViewPriceListRowModel): boolean {
        if (!this.order.OrderRows)
            this.order.OrderRows = [];

        var newRow = new ViewOrderRowsModel();
        newRow.Amount = 1;
        newRow.ReplacementCount = 0;
        newRow.ArticleNo = item.ArticleNo;
        newRow.IsStandardArticle = false;

        var alreadyAdded = this.order.OrderRows.filter(function (n, i) { return n.ArticleNo == newRow.ArticleNo; })[0] != undefined;

        if (!alreadyAdded && item !== undefined) {
            newRow.Description = item.Description;

            newRow.SalesPrice = item.SalesPrice;
            newRow.ConceptFee = item.ConceptFee;
          newRow.ServiceFee = item.ServiceFee;
            // Special case for denmark where service fee is different for different trailers. Lars promises to remove this anomaly asap.

          if (item.ArticleNo == "311847" && this.order.Customer.XalAccountNo == '54497')
            newRow.ServiceFee = 62;

          newRow.TotalCost = newRow.SalesPrice! + newRow.ServiceFee! + newRow.ConceptFee!;

          this.order.OrderRows.push(newRow);

          if (newRow.ArticleNo.toUpperCase().includes('NG') && !this.order.StripingMiscInfo.includes('Dekaliseringsplåtar'))
            this.order.StripingMiscInfo += '\n\nDekaliseringsplåtar';
      }

       

        this.updateTotal();
        this.sortOrderRows();
        this.articleSearch('');
        return true;
    }

    private sortOrderRows() {
        if (this.order.OrderRows != undefined) {
            this.order.OrderRows!.sort((a: ViewOrderRowsModel, b: ViewOrderRowsModel) => {
                if (a.IsStandardArticle && b.IsStandardArticle) return 0;
                if (!a.IsStandardArticle && !b.IsStandardArticle) return 0;
                if (b.IsStandardArticle) return -1;
                else return 1;
            });
        }
    }

    // Customer handling
    private loadUsers(): Promise<any> {
        var token = this.UI.beginLoading("TO.Order.loadingUsers", "Loading users", null);
        return this.Api.get<UserDropDownModel[]>("/TurboOrder/GetUsers").then(x => {
            this.users = x;
            this.UI.loaderCompleted(token);
        });
    }

    // bisnode
    public async loadCustomerInfo(customerId: number, orgno: string, updateValues:boolean = true ) {
        this.loading.customer = true;
        this.Api.get<OrderCustomerModel>("/TurboOrder/ResolveCustomer", { id: customerId, orgno: orgno }).then(async x => {
            this.order.OrgNo = x.OrgNo;

            this.order.CustomerId = x.Id;
            if (x.Id > 0) {
                this.order.Customer = x;
                this.getTrailers();
            }
            else this.order.Customer = undefined;

            this.order.LegalOrgNo = x.LegalOrgNo;
            this.order.LegalAddressCustomerName = x.LegalAddressCustomerName;
            this.order.LegalAddress = x.LegalAddress;
            this.order.LegalZipCode = x.LegalZipCode;
            this.order.LegalCity = x.LegalCity;
            this.order.LegalCountry = x.Country;
            this.order.Phone = x.Phone;
            this.order.DeliveryEmail = x.Mail;

            this.order.InvoiceName = x.InvoiceName;
            this.order.InvoiceStationNo = x.BFIKNR;
            this.order.InvoiceAddress = x.InvoiceAddress;
            this.order.InvoiceZipCode = x.InvoiceZipCode;
            this.order.InvoiceCity = x.InvoiceCity;
            this.order.InvoiceAccount = x.InvoiceAccount;
            this.order.PaymentMethod = x.PaymentMethod;
            this.order.BFIKNR = x.BFIKNR;

            this.order.DeliveryAddressCustomerName = x.DeliveryAddressCustomerName;
            this.order.DeliverySubsidiary = x.Subsidiary;
            this.order.DeliveryAddress = x.DeliveryAddress;
            this.order.DeliveryZipCode = x.DeliveryZipCode;
            this.order.DeliveryCity = x.DeliveryCity;
            this.order.DeliveryPhone = x.Phone;

            this.customerNumber = x.CustomerNumber;

            if (x.PriceListId) {
                this.order.PriceListId = x.PriceListId;
                await this.changePricelist(updateValues);
            }

            if (x.Country == "Denmark") {
                this.order.PaymentAtBeginningOfPeriod = false;
            } else {
                this.order.PaymentAtBeginningOfPeriod = true;
            }

            this.loading.customer = false;
        });
    }

    public async loadOrder(): Promise<ViewOrderModel> {
        var token = this.UI.beginLoading('TO.Order_msgLoading', 'Loading order', () => {
            this.router.navigateByUrl("/TurboOrder");
        });

        return new Promise<ViewOrderModel>((resolve, reject) => {
            this.Api.get<ViewOrderModel>("/TurboOrder/GetOrder", { id: this.orderId }).then(async data => {
                this.order = data;

                for (var i = 0; i < data.OrderRows!.length; i++) {
                    if (data.OrderRows![i].ArticleNo == "500000") this.serviceArticle = data.OrderRows![i];
                    if (data.OrderRows![i].ArticleNo == "600000") this.conceptArticle = data.OrderRows![i];
                }

                if (this.order.Customer)
                    await this.loadCustomerInfo(this.order.Customer.Id, '', false);
                else {
                    await this.changePricelist(false);
                }

                this.state.readonly = (this.order.Status >= 25);
              this.sortOrderRows();

              this.paymentTerms = this.order.PaymentAtBeginningOfPeriod ? 0 : 1;

                resolve(this.order);
                this.UI.loaderCompleted(token);
            }).catch(data => {
                reject();
                //$rootScope.setError({
                //    headline: 'Kunde inte hämta order',
                //    message: data.Message,
                //}, data);
            });
        });
    }

    // options: { reload: bool }
  public saveOrder(): Promise<ViewOrderModel | null> {
    let invalidMessages = [];
    if (this.order.Ownership == "SellAndLeaseBack" && this.Settings.isInAny(["Admin", "BackOffice"]) && this.order.Status == 5) {
      if (this.order.OrderRows && this.order.OrderRows.length > 0) {
        this.order.OrderRows.forEach(orderRow => {
          if (orderRow.OriginalValue != null) {
            const contractValueCount = orderRow.OriginalValue.toString().replace('.', '').replace('-', '');

            if (contractValueCount.length < 5) {
              invalidMessages.push("Price for " + orderRow.Description + " seems a bit low. Are you sure it's correct?");
            } else if (contractValueCount.length > 5) {
              invalidMessages.push("Price for " + orderRow.Description + " seems a bit high. Are you sure it's correct?");
            }
          }
        });
      }
    }
    if (invalidMessages.length > 0) {
      return this.UI.confirm('TO.Order.ContractValueWarning', 'Warning - Contract value', 'TO.Order.msgContractValuesWarning', "{0}", null, invalidMessages).then(x => {
        if (!x) return null;
        var token = this.UI.beginLoading('TO.Order_msgSaving', 'Saving order', null);
        this.order.OrderType = (this.order.Ownership == "Own") ? 5 : 7;
        this.order.PaymentAtBeginningOfPeriod = (this.paymentTerms == 0);
        return this.Api.post<ViewOrderModel>("/TurboOrder/SaveOrder?orderId=" + this.orderId, this.order).then(x => {
          if (!this.order.Id) {
            this.router.navigateByUrl("/TurboOrder/Order/" + x.Id);
          } else {
            //this.order = x;
          }
          this.UI.loaderCompleted(token);
          return x;
        });
      });
    }
    else {
      var token = this.UI.beginLoading('TO.Order_msgSaving', 'Saving order', null);

      this.order.OrderType = (this.order.Ownership == "Own") ? 5 : 7;
      this.order.PaymentAtBeginningOfPeriod = (this.paymentTerms == 0);

      return this.Api.post<ViewOrderModel>("/TurboOrder/SaveOrder?orderId=" + this.orderId, this.order).then(x => {
        if (!this.order.Id) {
          this.router.navigateByUrl("/TurboOrder/Order/" + x.Id);
        } else {
          //this.order = x;
        }

        this.UI.loaderCompleted(token);

        return x;
      });
    }
  }

  private dllToken: string;
    public async finalizeOrder() {
      if (this.order.Ownership == "SellAndLeaseBack" && !this.Settings.isInAny(["BackOffice"])) {
        var csToken = this.UI.beginLoading('TO.Order_msgSavingCS', 'Sending order to customer service', null);
        await this.saveOrder().then(x => {
            this.Api.get("/TurboOrder/SendToCustomerService", { orderId: this.order.Id }).then(x => {
            this.UI.loaderCompleted(csToken);
            this.loadOrder();
          });
        });
        this.UI.alert("TO.Order.SentToCustomerService", "Sent to customer service", "TO.Order.msgSentCustomerService", "Your order {0} has been sent to customer service.", null, [this.order.Id]);
      }
      else {
        this.saveOrder().then(x => {
          if (!x) return;
          this.order.Status = 10;
          this.UI.confirm('TO.Order.confirmStripingHeadline', 'Is the striping correct?', 'TO.Order.confirmStripingMessage', '"{0}"', null, [this.order.StripingMisc]).then(x => {
            if (!x) return;

            if (this.order.Ownership == "Financed") {
              this.dllToken = this.UI.beginLoading('TO.Order_msgPreparingDll', 'Contacting De lage Landen', () => {
                this.loading.isPreparingDLL = false;
              });

              this.loading.isPreparingDLL = true;
              this.Api.get("/TurboOrder/SendToDLL", { orderId: this.orderId, validate: true }).then(x => {
                this.dllData = x;

                setTimeout(() => {
                  document.forms[0].submit();
                }, 100);
                this.UI.loaderCompleted(this.dllToken);
              }).catch(x => {
                this.UI.loaderCompleted(this.dllToken);
                this.loading.isPreparingDLL = false;
              });
            }
            else {
              //öppna kvitto i ny flik
              var token = this.UI.beginLoading('TO.Order_msgGeneratingOrderDocument', 'Creating document', null);
              this.Api.get("/TurboOrder/RentalReceipt", { id: this.order.Id }).then(x => {
                this.UI.loaderCompleted(token);
                this.loadOrder();
              });
            }
          });
        });
      }
    }

    public dllLoaded(event: any) {
        if (this.loading.isPreparingDLL) {
            this.state.showDLL = true;
            this.UI.loaderCompleted(this.dllToken);
            this.loading.isPreparingDLL = false;
        }
    }
   

    public closeDLL() {
      this.state.showDLL = false;
      this.loading.isPreparingDLL = false;
    }

  public updateOrderRowsWithNewPrice() {
    if (this.state.readonly) return;
        for (var i = 0; i < this.order.OrderRows!.length; i++) {
            var row = this.order.OrderRows![i];
            if (row.IsStandardArticle) continue;

            var article = this.getArticlePrice(row.ArticleNo);
            if (article !== undefined) {
                row.Description = article.Description;
                row.SalesPrice = article.SalesPrice;
                row.ServiceFee = article.ServiceFee;
              row.ConceptFee = article.ConceptFee;
              // Special case for denmark where service fee is different for different trailers. Lars promises to remove this anomaly asap.

              if (article.ArticleNo == "311847" && this.order.Customer.XalAccountNo == '54497')
                row.ServiceFee = 62;

                row.TotalCost = row.SalesPrice! + row.ServiceFee! + row.ConceptFee!;
            }
            else {
                this.order.OrderRows!.splice(i, 1);
                i--;
            }
        }

        this.updateTotal();
    }

    public removeOrderRow(index: number) {
        this.UI.confirm("TO.Order.headConfirmRemoveRow", "Remove item?", "TO.Order.msgConfirmRemoveRow", "Are you sure you want to remove this item?").then(x => {
            if (x) {
                this.order.OrderRows!.splice(index, 1);
              this.updateTotal();

              //If there is no NG article number, and we have the comment added from when we add a NG model. We Remove it.
              if (!this.order.OrderRows.some(x => x.ArticleNo.toUpperCase().includes('NG')) && this.order.StripingMiscInfo.includes('Dekaliseringsplåtar')) {

                const ngComment = 'Dekaliseringsplåtar';
                const commentIndex = this.order.StripingMiscInfo.indexOf(ngComment);

                if (commentIndex !== -1) {
                  this.order.StripingMiscInfo =
                    this.order.StripingMiscInfo.slice(0, commentIndex) +
                    this.order.StripingMiscInfo.slice(commentIndex + ngComment.length);
                }
              }
            }
        });
     }

    public async changePricelist(changeValues: boolean = true) {
          if (this.order.PriceListId) {
            this.items = await this.Api.get<ItemOrderInfo[]>("/TurboOrder/GetItemsForPricelist", { pricelistId: this.order.PriceListId });

            this.Api.get<ViewPriceListModel>("/TurboOrder/GetPriceList", { id: this.order.PriceListId }).then(x => {
              this.priceList = x;
              this.priceList.Rows = this.priceList.Rows!.filter(row => this.isPriceListRowAvailable(row)).sort((a, b) => {
                  if (a.ArticleNo < b.ArticleNo) return -1;
                  return 1;
                });
                this.articleSearch('');

                const concept = this.concepts.find(c => c.value == this.order.Concept);
              this.order.StripingManual = 'Concept: ' + (concept?.text ?? "") + ', ' + x.Title;
              this.order.StripingMisc = this.order.DeliveryAddressCustomerName + ' (' + this.customerNumber + '), ' + this.order.DeliveryAddress + ", " + this.order.DeliveryPhone;

                for (var i = 0; i < this.order.OrderRows!.length; i++) {
                    if (this.order.OrderRows![i].IsStandardArticle) {
                        this.order.OrderRows!.splice(i, 1);
                        i--;
                    }
                }

                if (changeValues) {
                    if (x.DefaultLength !== undefined) this.order.Duration = x.DefaultLength;
                    this.order.AddServiceFee = (x.Fees.toLowerCase().indexOf("service") >= 0);
                }

                this.updateOrderRowsWithNewPrice();
                this.updateTotal();
            }).catch(x => {

            });
        }
    }

  private isPriceListRowAvailable(row: ViewPriceListRowModel): boolean {
    return this.items.some(item => {
      const articleMatches = item.ArticleNo === row.ArticleNo;
      const conceptMatches = !item.Concept || item.Concept.toLowerCase().split(',').map(x => x.trim()).includes(this.order.Concept.toLowerCase());
      const countryMatches = !item.Country || item.Country === this.order.LegalCountry;
      return articleMatches && conceptMatches && countryMatches;
    });
  }

    public setSigned() {
        this.UI.confirm("TO.Order.headSignedManually", "Confirm manual signing", "TO.Order.msgSignedManually", "Where the document really signed manually? If it was digitally signed it will be updated automatically.").then(x => {
            if (x) {
                this.order.Status = 25;
                this.Api.post<ViewOrderModel>("/TurboOrder/SetSigned?orderid=" + this.order.Id).then(x => { this.order = x; });
            }
        });
    }

    public reactivate() {
        this.UI.confirm("TO.Order.headReactivate", "Re-activate order?", "TO.Order.msgReactivate", "Are you sure you want to re-activate this order?").then(x => {
            if (x) {
                var token = this.UI.beginLoading('TO.Order.loadReactivate', 'Re-activating', null);
                this.order.Status = this.order.AgreementDocumentExists ? 10 : 1;
                this.Api.post<ViewOrderModel>("/TurboOrder/Reactivate?orderid=" + this.order.Id).then(x => {
                    this.order = x;
                    this.UI.loaderCompleted(token);
                });
            }
        });
    }

    public cancelOrder() {
        this.UI.confirm("TO.Order.headConfirmCancelOrder", "Cancel order?", "TO.Order.msgCancelOrder", "Are you sure you want to cancel the order?").then(x => {
            if (x) {
                this.Api.post("/TurboOrder/CancelOrder?id=" + this.order.Id).then(x2 => {
                    this.router.navigateByUrl("/TurboOrder");
                    this.loading.fullPage = false;
                });
            }
        });
    }

    public sendToAX() {
        this.loading.fullPage = this.loading.sending2Ax = true;
        this.Api.post<ViewOrderModel>("/TurboOrder/SendToAx?id=" + this.order.Id).then(x => {
            this.order = x;
            this.loading.fullPage = this.loading.sending2Ax = false;
        }).catch(x => {
            //this.log("GetSettings failed", data);
            this.loading.fullPage = this.loading.sending2Ax = false;
            //$rootScope.setError({
            //    headline: 'Kunde inte skicka till AX',
            //    message: 'Vänligen försök igen',
            //});
        });
    }

    private getTrailers() {
        this.Api.get<RentalContractInfo[]>("/TurboOrder/GetActiveTrailersForCustomer", { customerId: this.order.CustomerId }).then(x => {
            this.trailers = x.sort((x, y) => {
                if (x.TerminationType && !y.TerminationType) return 1;
                if (!x.TerminationType && y.TerminationType) return -1;
                if (x.TerminationDate! < y.TerminationDate!) return -1;
                if (x.TerminationDate! > y.TerminationDate!) return 1;

                return 0;
            });
        });
  }

  OnServiceFeeChange(event: MatCheckboxChange): void {
    this.updateTotal();
  }
}
